import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { G_TagsTypeViewModel } from 'src/app/viewmodels/g-settings/G_TagsTypeViewModel';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { ItemViewModel } from 'src/app/viewmodels/ItemViewModel';
import { AppConsts } from 'src/app/common/app-consts';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { G_BrandsViewModel } from 'src/app/viewmodels/g-settings/G_BrandsViewModel';
import { G_ModelsViewModel } from 'src/app/viewmodels/g-settings/G_ModelsViewModel';
import { FuleTypeComponent } from '../../g-settings/fule-type/fule-type.component';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExportExcel } from 'src/app/viewmodels/ExportExcel';
import { SaveGVehicleRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrls: ['./vehicle.component.scss']
})
export class VehicleComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  modalRefLv3: BsModalRef;
  public component_Title = 'Manage Vechicle';
  public vmListItems: any = [];
  public statusListItems: any = [];
  public SortBy: string = "asc";
  public itemVm: SaveGVehicleRequest = new SaveGVehicleRequest();
  dataTable: any;
  dtOption: any = {};

  public deleteId: string;
  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';

  public customerDetail: any = null;
  public selectedcustomerDetail: any = null;
  public exportFormat: string = 'csv';
  public vehicleStatus: number = 0;
  startDate: any = null;
  endDate: any = null;
  public CustomerDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',  // The field to use for the selected ID
    textField: 'name',  // The field to use for displaying the customer name
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getList();
    $('table.display').DataTable();
    //   this.getList();
    //   this.dtOption = {
    //     "paging":   false,
    //     "searching": false,
    //     "info": false,
    // };
    // $(() =>{
    //   $('table.display').DataTable(this.dtOption);
    // })
  }

  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
      this.modalRefLv1.setClass('modal-lg');
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
    if (lvl == 3) {
      this.modalRefLv3 = this._modalService.show(template);
    }
  }

  ngAfterViewInit() {
  }

  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSettingService.getList("GSetting", "GetGVehiclesAsync", this.p, this.size, search, this.orderBy, this.sort)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }


  // getList() {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this._uow.vehicleService.GetPagedResult().subscribe((res: any) => {
  //     this.vmListItems = res.DtlList;
  //     console.log(res);
  //     debugger
  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //   }, (err) => {
  //     console.log(err);
  //     this.spinner.hide();
  //     Swal.fire(
  //       'Failure!',
  //       'Network Issue!',
  //       'error'
  //     )
  //   });
  // }

  // getSortIndexList(sIndex) {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this.SortBy = this.SortBy == "asc" ? "desc" : "asc";
  //   this._uow.vehicleService.GetPagedResultBySort(0, 50, AppConsts.VEHICLE, sIndex, this.SortBy).subscribe((res: any) => {
  //     debugger
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res.DtlList;;
  //     console.log(res);
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     this.spinner.hide();
  //   });
  // }

  // public searchTerm = '';
  // getBySearchTerm(e) {
  //   if (this.searchTerm !== ' ') {
  //     // this._jq.showSpinner(true);
  //     this.spinner.show();
  //     this._uow.vehicleService.GetPagedBySearch(this.searchTerm).subscribe((res: any) => {
  //       this.p = 1;
  //     this.vmListItems = res.DtlList;
  //       // this._jq.showSpinner();
  //     this.spinner.hide();
  //     }, (error) => {
  //       console.log(error);
  //       // this._jq.showSpinner();
  //     this.spinner.hide();

  //     });
  //   }
  // }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SaveGVehicleRequest();
    }
  }
  // saveOrUpdate() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.Post(this.vm).subscribe((res: any) => {
  //     this.getList();
  //     this.modalRefLv1.hide();
  //   }, (err) => {
  //     this._jq.showSpinner();
  //   });
  // }
  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;

    }
  }

  conformDelete() {
    this.spinner.show();
    this._uow.gSettingService.DeleteGVehicleAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRefLv1.hide();
      this.spinner.hide();
    }, (err) => {
      // this._jq.showSpinner();
      this.spinner.hide();
    });
  }

  // external components
  onItemSubmitted(e) {
    if (e == true) {
      this.getList();
      this._jq.showSpinner(false);
    }
  }


  openExportModel(template: TemplateRef<any>) {
    this.openModal(template, 1);
    this.loadVehicleFormAsync();
  }

  openStatusModel(template: TemplateRef<any>, model) {
    this.openModal(template, 2);
    debugger
    this.itemVm = model;
    this.vehicleStatus = this.itemVm.status.id;
    this.getVehicleStatusName();
  }

  loadVehicleFormAsync() {
    debugger;
    this._uow.gSettingService.LoadVehicleFormAsync().subscribe(
      (res: any) => {
        debugger;
        this.customerDetail = res.customers.map(x => {
          return {
            id: x.id, // or the actual ID field
            name: x.name // concatenated name and code
          };
        });

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }


  getVehicleStatusName() {
    debugger;
    this._uow.gSettingService.GetVehicleStatusesAsync().subscribe(
      (res: any) => {
        debugger;
        this.statusListItems = res.result.map(x => {
          return {
            id: x.id, // or the actual ID field
            name: x.name // concatenated name and code
          };
        });

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }


  exportToExcel() {
    debugger;
    this.spinner.show();
    var id = 0;
    if(this.selectedcustomerDetail == null || this.selectedcustomerDetail == undefined)
      id = 0;
    else{
      id = this.selectedcustomerDetail[0].id;
    }
    this._uow.gSettingService.GetGVehiclesExportAsync(id, this.startDate, this.endDate).subscribe(
      (res: any) => {
        debugger;
       this.openLinkInNewTab(res.file);
        this.spinner.hide();

      },
      (error) => {
        debugger
        this.spinner.hide();
        this._uow.logger.log(error);
         Swal.fire(
          'Failure!',
          'Records was not found!',
          'error'
        )
      }
    );
  }

  openLinkInNewTab(url) {
    window.open(url,'_blank');
  }



  saveOrUpdate() {
    debugger
    // this._jq.showSpinner(true);
    this.itemVm.status.id = this.vehicleStatus;
    this.spinner.show();
    this._uow.gSettingService
      .SaveGVehicleAsync(this.itemVm)
      .toPromise().then((res: any) => {
        console.log(res);
        this.spinner.hide();
        Swal.fire(
          'Created!',
          'Vehicle Status Updated!',
          'success'
        )
        this.getList();
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          'Vehicle Status Not Updated!',
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        console.log(error);
        this.spinner.hide();
      });
  }
}
